// extracted by mini-css-extract-plugin
module.exports = {"wrap":"BlockErrorMessage_wrap__OJb3U","text":"BlockErrorMessage_text__6qwf1"};